import React from 'react'

export default function AdminDashbaordPage() {
  return (
    <div>AdminDashbaordPage</div>
  )
}
